export default [
  {
    path: '/plans/dump/list',
    name: 'plans.dump.list',
    component: () => import('@/views/modules/plans/dump-plan/ListDumpPlans'),
    meta: {
      module: 'plans.dump',
      pageTitle: 'List All dump Plans',
      breadcrumb: [
        { text: 'List dump Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.dump.create'} }
      ],
    }
  },


  {
    path: '/plans/dump/create',
    name: 'plans.dump.create',
    component: () => import('@/views/modules/plans/dump-plan/CreateDumpPlan'),
    meta: {
      module: 'plans.dump',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.dump.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/dump/:id/edit',
    name: 'plans.dump.edit',
    component: () => import('@/views/modules/plans/dump-plan/EditDumpPlan'),
    meta: {
      module: 'plans.dump',
      pageTitle: 'Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.dump.list'} },
        { text: 'Create Plan' , to: {name: 'plans.dump.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
